module.exports = __webpack_public_path__ + "static/media/send-message-btn-mobile.a28e7af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/send-message-btn-mobile.png
// module id = 299
// module chunks = 0